<template>
    <div>
        <button
            class=" text-sm text-secondary underline focus:outline-none flex content-center"
            @click="clickButton"
        >
            <slot>
                {{ $t(desp) }}
            </slot>
        </button>
        <modal v-if="showExternUrlModal" type="custom" @backdrop="hide">
            <div class="text-darkGrayishBlue text-lg sm:m-4 flex flex-col">
                <div class="flex flex-row justify-center">
                    <img :src="logoUrl" alt="TryHaLa" class=" h-16" />
                </div>
                <div class="text-base mt-4">
                    {{
                        '注意：您點選的連結會帶您離開「試吓啦」網站，並重新導向至第三方網站，「試吓啦」不代表第三方網站，對其品質、內容、可靠性或安全性不承擔任何監督或管控的義務，同時「試吓啦」對第三方網站的使用也不承擔任何責任。'
                    }}
                </div>

                <div class="flex mt-8 justify-between">
                    <button
                        class="btn py-2 mr-2 sm:mr-4 w-1/2 justify-center"
                        @click="hide"
                    >
                        <div>{{ '返回「試吓啦」' }}</div>
                    </button>
                    <button
                        class="btn bg-primary py-2 ml-2 sm:ml-4 w-1/2 justify-center"
                        @click="openUrl"
                    >
                        <div>{{ '繼續前往' }}</div>
                    </button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import modal from '@/components/modal.vue';
import logo7 from '@/assets/logo7_optimized.jpg';

function isTryHaLaUrl(url) {
    try {
        return new URL(url).hostname === 'tryhala.com';
    } catch (e) {
        return false;
    }
}

export default {
    components: {
        modal
    },
    props: {
        url: { type: String, required: true },
        desp: { type: String, default: '更多產品資訊' }
    },
    data: () => ({
        showExternUrlModal: false
    }),
    created() {
        this.logoUrl = logo7;
    },
    methods: {
        clickButton() {
            if (isTryHaLaUrl(this.url)) {
                this.openUrl();
            } else {
                this.show();
            }
        },
        show() {
            this.showExternUrlModal = true;
        },
        hide() {
            this.showExternUrlModal = false;
        },
        openUrl() {
            window.open(this.url);
            this.showExternUrlModal = false;
            this.$emit('openUrl');
        }
    }
};
</script>
